module.exports = __webpack_public_path__ + "static/media/seal_reversed.dda5c060.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals/CA/seal_reversed.svg
// module id = 1078
// module chunks = 0